import {AllApiSchema} from '@shared/api/core/api_schema';
import {ApiConfig, ApiName} from '@shared/api/core/api_types';
import {WEBSITE_BACKEND_API} from '@shared/api/website_backend_api';
import {WEBSITE_BACKEND_URL} from '@shared/env';

export const ALL_APIS = {
  website_backend: WEBSITE_BACKEND_API,
} satisfies AllApiSchema;

export const ALL_API_CONFIGS = {
  website_backend: {host: WEBSITE_BACKEND_URL},
} satisfies Record<ApiName, ApiConfig>;
